export const loadingShimmerCss = {
  width: '100%',
  height: '30px'
};
